mutation SubmitEncryptedCredentials(
  $agentRegistrationId: ID!
  $encryptedCredentials: String!
  $name: String
) {
  submitEncryptedCredentials(
    input: {
      agentRegistrationId: $agentRegistrationId
      encryptedCredentials: $encryptedCredentials
      name: $name
    }
  ) {
    agentRegistration {
      id
      databaseId
      status
    }
    errors
  }
}